import { ReactElement } from 'react'
import styled from 'styled-components'
import { I18n, Translate } from 'common'

interface Props {
  logoUrl: string
  orderDate: string
}

const ReceiptHeader = (props: Props): ReactElement => {
  const { logoUrl, orderDate } = props

  return (
    <Wrapper>
      <LogoImage src={logoUrl} alt="My place 4 parts logo" />
      <HeaderCenter>
        <Title>
          <I18n name="orderConfirmation" />
        </Title>
      </HeaderCenter>
      <HeaderRight>{Translate('orderedOn', [orderDate])}</HeaderRight>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  padding: 0 0 6px;
  font-size: 11pt;
  line-height: 14pt;
`

const LogoImage = styled.img`
  width: auto;
  height: 40px;
  justify-self: start;
`

const HeaderCenter = styled.div`
  justify-self: center;
  text-align: center;
`

const Title = styled.div`
  font-family: Oswald, serif;
  font-weight: 700;
  font-size: 13pt;
  line-height: 14pt;
`

const HeaderRight = styled.div`
  justify-self: end;
  text-align: right;
  font-size: 11pt;
  white-space: nowrap;
`

export default ReceiptHeader
